import dayjs from "@/lib/dayjs";
type Props = {
	amount: number;
	date: string;
	format?: string;
};

export const addMonth = ({ amount, date, format = "YYYY-MM-DD" }: Props) => {
	return dayjs(date).add(amount, "month").format(format);
};
